import { Box, FormControlLabel, Checkbox } from "@mui/material";
import type { FormData } from "./template-advanced-config";

interface TemplateValidationRulesProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

const TemplateValidationRules = ({
  formData,
  setFormData,
}: TemplateValidationRulesProps) => {
  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", pl: 1 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.allowLetters}
            onChange={(e) =>
              setFormData({
                ...formData,
                allowLetters: e.target.checked,
              })
            }
            size="small"
          />
        }
        label="Allow Letters"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.allowNumbers}
            onChange={(e) =>
              setFormData({
                ...formData,
                allowNumbers: e.target.checked,
              })
            }
            size="small"
          />
        }
        label="Allow Numbers"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.allowSpaces}
            onChange={(e) =>
              setFormData({
                ...formData,
                allowSpaces: e.target.checked,
              })
            }
            size="small"
          />
        }
        label="Allow Spaces"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.allowFutureDates}
            onChange={(e) =>
              setFormData({
                ...formData,
                allowFutureDates: e.target.checked,
              })
            }
            size="small"
          />
        }
        label="Allow Future Dates"
      />
    </Box>
  );
};

export default TemplateValidationRules;
